// extracted by mini-css-extract-plugin
module.exports = {"wbgvek4":"wbgvek4","lqr8por":"lqr8por","loader":"loader","brrtnjr":"brrtnjr"};